/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.PICKLIST = function () {

    this.resourceKey = 'Survey.Sidebar.SelectOne';
    this.jsonType = 'PICKLIST';

    this.textAreaId = 'SelectOneAnswer';
    this.bodyClass = "selectOneBody";

    Greenmile.Survey.Sidebar.GenericMultiAnswers.apply(this, arguments);

    this.validate = function (defaultValue, answerOptions) {
        var errors = [],
            value  = answerOptions.filter(function (value) {
                return value.value === defaultValue;
            });

        if (defaultValue && !value.length) {
            errors.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.defaultValueIsNotOneOption'));
        }

        return errors;
    };

    this.serializeInput = function (questionData) {

        var maxLength = 255;

        var questionElement = document.querySelector(this.questionDescriptorSelector),
            answerElement   = document.querySelector('#' + this.textAreaId),
            defaultValue    = (this.fieldDefaultAnswer ? this.fieldDefaultAnswer.getValue() : '');

        var questionText  = questionElement.value,
            answerText    = answerElement ? answerElement.value : '',
            options       = answerText.split('\n'),
            answerOptions = options.map(function (option) {
                return { description: option, value: option };
            });

        var hiddenType   = document.getElementsByName('questionType')[0],
            questionType = hiddenType.value;

        answerOptions = Greenmile.Survey.Sidebar.answerCropExceedLength(answerOptions, maxLength);
        defaultValue = defaultValue ? (Greenmile.Survey.Sidebar.answerCropExceedLength([{ value: defaultValue}], maxLength))[0].value : '';

        return {
            questionType: questionType,
            questionText: questionText,
            answerOptions: answerOptions,
            defaultAnswer: defaultValue,
            errors: this.validate(defaultValue, answerOptions)
        };

    };

    this.addQuestionContent = function (questionContent, input) {
        var answers                = input.answerOptions,
            answerContent          = questionContent.querySelector('.answerContent'),
            newQuestionDescription = questionContent.querySelector('.newQuestionDescription'),
            radioGroup             = new Monet.UI.Fields.RadioGroup(),
            radios                 = radioGroup.getRadioButtons(),
            questionText           = input.questionText,
            defaultAnswer          = input.questionData ? input.questionData.defaultAnswer : input.defaultAnswer;

        answerContent.innerHTML = '';
        newQuestionDescription.title = questionText;
        newQuestionDescription.innerHTML = questionText;
        questionContent.setAttribute('questionType', input.questionType);

        if (answers) {

            for (var i = 0; i < answers.length; i++) {

                var radio,
                    answer = answers[i],
                    edit   = Greenmile.Survey.Widgets.editLink(answer),
                    remove = Greenmile.Survey.Widgets.removeLink(answer),
                    link   = Greenmile.Survey.Widgets.answerLink(answer, input.questionData),
                    drag   = document.createElement('div'),
                    label,
                    value  = answer.value;

                radio = new Monet.UI.Fields.Render({
                    type: 'RADIO',
                    name: questionContent.getAttribute('question_id'),
                    value: value,
                    label: value
                }, 'Survey').render();

                if (Greenmile.Survey.Builder.releasedDate) {

                    edit.style.display = 'none';
                    remove.style.display = 'none';
                    link.style.display = 'none';

                }

                drag.className = 'dragQuestionDomain';

                label = radio.rootEl.getElementsByTagName('label')[0];
                label.title = value;

                var radioInput = radio.rootEl.querySelector('input[type="radio"]');
                radio.rootEl.insertBefore(drag, radioInput);

                radio.input.checked = ( value === defaultAnswer);
                radio.rootEl.id = answer.id;
                radio.rootEl.appendChild(edit);
                radio.rootEl.appendChild(remove);
                radio.rootEl.appendChild(link);
                radios.push(radio);

            }
        }

        answerContent.appendChild(radioGroup.render());

        var questionID = questionContent.getAttribute('question_id');
        $('div[question_id="' + questionID + '"] .answerContent .optionGroup').sortable({ axis: "y" });

    };

    this.serializeContent = function (question) {
        var radios         = question.el.parentNode.querySelectorAll('.newQuestionContent[question_id="' + question.id + '"] > .answerContent > .optionGroup input[type="radio"]'),
            answer,
            action         = Greenmile.Survey.Builder.action,
            radiosToReturn = [],
            parentNode,
            i,
            radio;

        for (i = 0; i < radios.length; i++) {

            radio = {};
            parentNode = radios[i].parentNode;
            answer = Greenmile.Survey.Data.findQuestionDomain(question, parentNode.id);

            if (answer.nextQuestion) {

                radio.nextQuestion = answer.nextQuestion;

            }

            if (answer.isNew !== true && action === 'update') {

                radio.id = answer.id;

            }

            radio.value = answer.value;
            radio.surveyQuestionDomainOrder = i;
            radiosToReturn.push(radio);

        }

        return radiosToReturn;
    };
};
